import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = N·m. */
export const TORQUE_PIVOT: Record<string, number> = {
  'n*m': 1,
  'kn*m': 1000,
  'lbf*ft': 1.35582,
  'lbf*in': 0.112985,
};

export const transformTorque = createPivotTransformer(TORQUE_PIVOT);
